const E = {
  'Balance Due': 'Balance Due',
  Paid: 'Paid',
  'All Invoices': 'All Invoices',
  'Pay Selected Invoices': 'Pay Selected Invoices',
  NoInvoices: 'There are currently no invoices available. If you need assistance, please contact your Bureau Veritas representative.',
  NoAccess: 'For access to invoices, please contact your Bureau Veritas representative.',
  NoResults: 'We couldn’t find any invoices that match your search criteria.',
  NoResultsBody: 'Please double check your search criteria or try a broader search. If you do not have access to this client or need further assistance please contact your Bureau Veritas representative.',
  MixedCurrency: 'Please pay Canadian and U.S. invoices on separate transactions.',
  POAFENumber: 'POAFENumber',
  'Site Location': 'Site Location',
  'Job #': 'Job #',
  Invoice: 'Invoice',
  'Invoice Date': 'Invoice Date',
};

const F = {
  'Balance Due': 'Solde dû',
  Paid: 'Payé',
  'All Invoices': 'Toutes les factures',
  'Pay Selected Invoices': 'Payer les factures sélectionnées',
  NoInvoices: 'Aucune facture disponible pour le moment. Si vous avez besoin d’aide, veuillez contacter votre représentant des Lab BV.',
  NoAccess: 'Pour accéder aux factures, veuillez contacter votre représentant des Lab BV.',
  NoResults: 'Aucune facture ne correspond à vos critères de recherche.',
  NoResultsBody: 'Veuillez vérifier les critères de recherche ou les élargir. Si vous avez besoin d’aide, veuillez contacter votre représentant des Lab BV.',
  MixedCurrency: 'Veuillez payer les factures en CAD et en USD séparément.',
  POAFENumber: 'No de PO ou d’AFE',
  'Site Location': 'Emplacement du site',
  'Job #': 'No de dossier',
  Invoice: 'Facture',
  'Invoice Date': 'Facture créée le',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/invoices.js